<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="100px">
    <el-form-item label="名称">
      <el-input :value="form.regionName" readonly />
    </el-form-item>
    <el-form-item label="负责人">
      <el-select-ex
        style="width: 100%"
        ref="sel"
        v-model="curEditItem.director"
        url="BasicInformation/RegionDirector/NotRegionForDirectorEntry"
        label-field="fName"
        value-field="fUserID"
        :extraParam="{ fid: form.regionID }"
        sel-first
      />
    </el-form-item>
    <el-form-item label="简介">
      <el-input v-model="curEditItem.fDes" />
    </el-form-item>
    <div style="text-align: center">
      <el-button v-if="canAdd" type="warning" size="small" @click="addDirector"
        >添加</el-button
      >
    </div>
    <el-table :data="tableData">
      <el-table-column prop="fRegionName" label="区域名称"> </el-table-column>
      <el-table-column prop="fName" label="区域负责人"> </el-table-column>
      <el-table-column prop="fDes" label="备注"> </el-table-column>
      <el-table-column label="操作" class-name="table-oper-col">
        <template slot-scope="scope">
          <template>
            <ConfirmButton @confirm="delDirector(scope.row)"
              >删除</ConfirmButton
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import ConfirmButton from "@components/ConfirmButton";

export default {
  props: {
    form: Object,
    canAdd: Boolean,
  },
  data: function () {
    return {
      curEditItem: {
        director: null,
        fDes: null,
      },
      rules: {},
      tableData: [],
    };
  },
  computed: {
    isEdit: function () {
      return !!this.form.fRegionID;
    },
  },
  mounted: function () {
    this.refresh();
  },
  methods: {
    refresh: function () {
      this.$httpPost("BasicInformation/RegionDirector/RegionForDirectorEntry", {
        fid: this.form.regionID,
      }).then((res) => {
        this.tableData = res.datalist;
      });
    },

    addDirector: function () {
      this.postData("Add", {
        fRegionID: this.form.regionID,
        fUserID: this.curEditItem.director,
        fDes: this.curEditItem.fDes,
      });
    },

    delDirector: function (row) {
      this.postData("Delete", {
        fRegionID: row.fRegionID,
        fUserID: row.fUserID,
      });
    },

    postData: function (type, data) {
      return this.$httpPost(
        `BasicInformation/RegionDirector/RegionForDirector${type}`,
        data
      ).then(async (res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
          this.$refs.sel.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
  },
  components: {
    ConfirmButton,
  },
};
</script>

<style lang="less" scoped>
</style>
